import { withLayout } from 'layouts';
import ManualEnrolment from './manual-enrolment.component';

export default withLayout(ManualEnrolment);
